// Kerala trip data — exact content from theunexploredroutes.com
const keralaTrip = {
  _id: '5',
  title: 'Kerala Backwaters & Hills',
  destination: 'Cochin, Munnar, Thekkady & Alleppey, Kerala',
  description: 'KERALA — God\'s Own Country. Fort Cochin\'s ancient spice-trading streets, Munnar\'s misty emerald tea estates at 1800m, Thekkady\'s famous Periyar wildlife sanctuary, and Alleppey\'s serene backwaters — Kerala packs four completely different worlds into one unforgettable journey.',
  duration: '6N/7D',
  price: 15999,
  originalPrice: 18500,
  maxGroupSize: 14,
  difficulty: 'Easy',
  category: 'Beach',
  coverImage: '/kerala.jpg',
  rating: 4.7,
  reviewCount: 53,
  highlights: [
    'Fort Cochin — Dutch Palace (1557), Jewish Synagogue (1568), Chinese Fishing Nets',
    'Munnar — Eravikulam National Park, NilgiriTahr, Tea Museum',
    'Maduppatty Dam, Echo Point, Kundalay Dam, Blossom Park',
    'Thekkady — Periyar Lake wildlife cruise (elephants, deer, wild boar)',
    'Alleppey/Kumarakom backwaters cruise through paddy fields',
    'All transfers and sightseeing by AC Vehicles (08:00 AM to 07:00 PM)',
    'Overnight houseboat experience on Kerala backwaters',
  ],
  itinerary: [
    {
      day: 1,
      title: 'Day 1 — Cochin (Arrival)',
      description: 'Arrival at Cochin and transfer to hotel. Check in at Hotel.\n\nIn Cochin visit the Dutch Palace — built by the Portuguese in 1557 and subsequently renovated by the Dutch after 1663. The murals are perhaps the best in India.\n\nJewish Synagogue — built in 1568 and the oldest Synagogue in the Commonwealth are at Mattancherry.\n\nSt. Francis Church — built in 1510 and the oldest European church in India.\n\nChinese Fishing Nets — introduced by the court of Kublai Khan can be seen in Fort Cochin. Fort Cochin Beach etc.\n\nOvernight stay at Cochin.',
      accommodation: 'Hotel in Cochin',
      meals: 'Dinner',
      image: '/kerala.jpg',
    },
    {
      day: 2,
      title: 'Day 2 — Cochin to Munnar',
      description: 'After breakfast check out from the hotel and transfer to Munnar. Munnar is 1800 mts above sea level and also the place of South India\'s highest peak (Anamudi — 2695 mts). On the way visit Valara, Cheeyappara waterfalls & Tea Plantations.\n\nOn arrival at Munnar transfer to Hotel. Check in at Hotel. Afternoon visit Rajamala (Eravikulam National Park — open as per the directions by the forest authorities), the best place to see NilgiriTahr (Hermitragus Hilarious) — the mountain goat of South India & Tea Museum.\n\nEvening have a short visit at Munnar town. You can see the beautiful tea estates like a green paradise.\n\nOvernight stay at Munnar.',
      accommodation: 'Hotel in Munnar',
      meals: 'Breakfast & Dinner',
      image: 'https://images.pexels.com/photos/5174013/pexels-photo-5174013.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop',
    },
    {
      day: 3,
      title: 'Day 3 — Munnar (Local Sightseeing)',
      description: 'After breakfast proceed for sightseeing. Maduppatty dam, Echo Point, Kundalay Dam, Pothenmedu View Point, Blossom Park etc are some of the highlights of the sightseeing.\n\nShopping & Overnight stay at Munnar.',
      accommodation: 'Hotel in Munnar',
      meals: 'Breakfast & Dinner',
      image: '/kerala.jpg',
    },
    {
      day: 4,
      title: 'Day 4 — Munnar to Thekkady',
      description: 'Munnar to Thekkady — Morning have breakfast at resort later check out resort and drive to Thekkady. Thekkady is a world famous wildlife sanctuary and it is also called as Periyar. On arrival check in Hotel.\n\nAfternoon proceed for a game viewing cruise on the Periyar Lake. Here you will be able to see a large variety of wildlife, which include elephants, monkeys, deer, wild boar etc.\n\nEvening you can take an Elephant ride at Periyar wild life and rest of the day is at leisure.',
      accommodation: 'Hotel in Thekkady',
      meals: 'Breakfast & Dinner',
      image: 'https://images.pexels.com/photos/2739664/pexels-photo-2739664.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop',
    },
    {
      day: 5,
      title: 'Day 5 — Thekkady to Alleppey/Kumarakom',
      description: 'After breakfast check out from the hotel and transfer to Alleppey/Kumarakom. Check in at the resort. Later proceed to visit Alleppey backwaters. Take a cruise (Optional — Own Cost) through the rich and splendid backwater. Just relax at the boat.\n\nIt will be a unique and exclusive experience in your lifetime. You will be cruising along the village sides and paddy fields witnessing the core life of the Kerala villages.\n\nOvernight stay at Alleppey/Kumarakom.',
      accommodation: 'Resort at Alleppey/Kumarakom',
      meals: 'Breakfast & Dinner',
      image: '/kerala.jpg',
    },
    {
      day: 6,
      title: 'Day 6 — Alleppey/Kumarakom to Cochin (Tour Ends)',
      description: 'Morning have breakfast at resort later check out Hotel and drive to Airport / Railway Station for departure.',
      accommodation: '-',
      meals: 'Breakfast',
      image: 'https://images.pexels.com/photos/2506923/pexels-photo-2506923.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop',
    },
  ],
  inclusions: [
    'Arrival and departure assistance',
    'Welcome Drink on arrival at all the hotels',
    'Accommodation on double/triple sharing basis',
    'Meal plan will be on CP (Room + Breakfast) at all the hotels',
    'All transfers and sightseeing by AC Vehicles (At disposal — As per the itinerary from 08.00 AM to 07.00 PM)',
    'All Driver Allowance, Toll Taxes, Parking Charges, Fuel Charges',
    'GST',
  ],
  exclusions: [
    'Any other services or food which are not mentioned in the above "Includes" section',
    'Expense of personal nature such as tips, laundry, telephones, beverages etc',
    'Airfares and Train ticket charges if any',
    'Any entrance Fees / Activities charges unless specific in inclusion',
  ],
  paymentTerms: [
    '50% Advance to confirm the reservation',
    'Balance 50% Payment before Departure of Trip at Leh',
  ],
  greeting: 'Dear Sir/Mam, Greetings from The Unexplored Routes!!! Thank you for providing me the opportunity for your holiday plans. I am pleased to attach suggested programme along with our very competitive price. I hope you like it. Best Regards, Manik Punjabi — The Unexplored Routes — 8109849232',
};

export default keralaTrip;
